export default import.meta.ROLLDOWN_FILE_URL_6M9td3YLx8eFPrYthtAXiA